/**
 * i18next Configuration for Chamama Booking App
 *
 * Supports Hebrew (he) and English (en) with RTL support for Hebrew
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import heAuth from './locales/he/auth.json';
import enAuth from './locales/en/auth.json';
import heCommon from './locales/he/common.json';
import enCommon from './locales/en/common.json';
import heBookings from './locales/he/bookings.json';
import enBookings from './locales/en/bookings.json';
import heAdmin from './locales/he/admin.json';
import enAdmin from './locales/en/admin.json';
import heSettings from './locales/he/settings.json';
import enSettings from './locales/en/settings.json';
import heEquipment from './locales/he/equipment.json';
import enEquipment from './locales/en/equipment.json';
import heStaff from './locales/he/staff.json';
import enStaff from './locales/en/staff.json';
import heExpertise from './locales/he/expertise.json';
import enExpertise from './locales/en/expertise.json';
import heAbout from './locales/he/about.json';
import enAbout from './locales/en/about.json';

// Translation resources
const resources = {
  he: {
    auth: heAuth,
    common: heCommon,
    bookings: heBookings,
    admin: heAdmin,
    settings: heSettings,
    equipment: heEquipment,
    staff: heStaff,
    expertise: heExpertise,
    about: heAbout
  },
  en: {
    auth: enAuth,
    common: enCommon,
    bookings: enBookings,
    admin: enAdmin,
    settings: enSettings,
    equipment: enEquipment,
    staff: enStaff,
    expertise: enExpertise,
    about: enAbout
  }
};

// Initialize i18next
i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n to react-i18next
  .init({
    resources,
    defaultNS: 'common',
    fallbackLng: 'he', // Default to Hebrew

    // Language detection options
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },

    // Interpolation options
    interpolation: {
      escapeValue: false // React already escapes values
    },

    // Set HTML dir attribute based on language
    react: {
      useSuspense: false
    }
  });

// Set document direction based on language
i18n.on('languageChanged', (lng) => {
  const dir = lng === 'he' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', lng);
});

// Set initial direction
const currentLang = i18n.language || 'he';
const dir = currentLang === 'he' ? 'rtl' : 'ltr';
document.documentElement.setAttribute('dir', dir);
document.documentElement.setAttribute('lang', currentLang);

export default i18n;
